
 const Loading: React.FC = ()=>{
  
    return (
      <>
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-[9999]">
            <div className="max-w-md w-full">
              <div className="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 animate-[spin_0.8s_linear_infinite] fill-blue-600 block mx-auto"
                viewBox="0 0 24 24">
                <path
                    d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
                    data-original="#000000" />
                </svg>
              </div>
            </div>
          </div>
      </>
    );
  };
  
  export default Loading;
  